import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import TermsOfService from '../views/TermsOfService.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import CodeAuthority from '../views/CodeAuthority.vue';
import CodeAuthorityTerms from '../views/CodeAuthorityTerms.vue';
import CodeAuthorityPrivacy from '../views/CodeAuthorityPrivacy.vue';
import CodeAuthorityHelp from '../views/CodeAuthorityHelp.vue';
import CodeAuthorityContent from '../views/CodeAuthorityContent.vue';
import UserSupport from '../views/UserSupport.vue';
import JimsView from '../views/JimsView.vue';

const routes = [
  { path: '/', component: HomeView },
  { path: '/jim', component: JimsView },
  { path: '/terms-of-service', component: TermsOfService },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/user-support', component: UserSupport },
  {
    path: '/construction-code-ai-assistant',
    component: CodeAuthority,
    children: [
      { path: '', component: CodeAuthorityContent},
      { path: 'help', component: CodeAuthorityHelp },
      { path: 'terms', component: CodeAuthorityTerms },
      { path: 'privacy', component: CodeAuthorityPrivacy },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;